<template>
	<van-grid :column-num="5">
	  <van-grid-item :icon="network" text="400热线" @click="toSvcnet()"/>
	  <van-grid-item :icon="webchat" text="在线客服" @click="toWebchat()"/>
	 <van-grid-item :icon="Driver" text="意见反馈" @click="toDriver()"/>
	  <van-grid-item :icon="tips" text="联系我们" @click="toTIPS()"/>
	   <van-grid-item :icon="srso" text="信创专线" @click="toSRSO()"/>
	   
	</van-grid> 
</template>

<script>
	
		export default {
		  name: 'toplink',
		  components: {},
		 data(){
				return{			
					 network: require("@/assets/topicon/demo2.png"),
					 webchat: require("@/assets/topicon/demo2.png"),
					 Driver: require("@/assets/topicon/demo2.png"),
					 srso: require("@/assets/topicon/demo2.png"),
					 tips: require("@/assets/topicon/demo2.png")					
					}
				}
		}
</script>

<style>
</style>
